import { useContext } from "react";
import NationalExecutiveCommittee from "../NationalExecutiveCommittee";
import PoliticalDocuments from "../PoliticalDocuments";
import { PoliticalPartyDBContext } from "../PoliticalPartyDBContext";
import PoliticalPartyInfo from "../PoliticalPartyInfo";
import RegistredAndNonRegistered from "../RegistredAndNonRegistered";
import PoliticalMembershipYearDropdown from "../PoliticalMembershipYearDropdown";



export default function () {
  var { contestationPeriodID } = useContext(PoliticalPartyDBContext);

  return (<>
    <div className="card">
      <PoliticalMembershipYearDropdown />
      {!["", null, undefined].includes(contestationPeriodID) && (<><RegistredAndNonRegistered   header={"Members"} isDialog={false} /></>)}
    </div>
  </>)
}